export interface UserServiceOfferInHospitalFilteredListRequestParams {
  filters: {
    hospital: {
      id: number
    }
    treatmentCategory: {
      id: number
    } | null
    treatment: {
      ids: number[] | never[]
    }
  }
  pagination: {
    pageSize: number
    pageIndex: number
  }
}

interface ExchangeRateAppliedPrice {
  originalAmount: number
  discountedAmount: number
  currency: string
}

export enum ServiceOfferBadge {
  SAT_DISCOUNT = 'SAT_DISCOUNT',
  PURCHASABLE = 'PURCHASABLE',
  RESERVATION = 'RESERVATION',
  IMMEDIATE_RESERVATION = 'IMMEDIATE_RESERVATION',
  WAITING_RESERVATION = 'WAITING_RESERVATION',
  EXCLUSIVE_PRICE = 'EXCLUSIVE_PRICE',
  OFFLINE_POINT = 'OFFLINE_POINT',
}

export interface UserServiceOfferInHospitalListItem {
  id: number
  title: string
  thumbnail: string
  targetLanguage: string
  operationType: string
  price: {
    originalAmount: number
    discountedAmount: number
    discountPercentage: number
    currency: string
    exchangeRateAppliedPrice: ExchangeRateAppliedPrice | null
  }
  includeVat: boolean
  rating: {
    totalRating: number
    ratingCount: number
  }
  badges: ServiceOfferBadge[]
  medicalCasesCount: number
  hospital: {
    id: number
    name: string
    country: string
  }
}

export interface UserServiceOfferInHospitalFilteredListView {
  totalPageNumber: number
  currentPageIndex: number
  pageSize: number
  isLastPage: boolean
  totalElementNumber: number
  contents: UserServiceOfferInHospitalListItem[]
}
